"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thunkMonitor = void 0;

var _actions = require("./actions");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getErrorData(exc) {
  var errorHasData = exc.data && Object.keys(exc.data).length;
  var excData = errorHasData && exc.data || {};
  return _objectSpread({
    message: "Operation failure."
  }, excData);
}

function recordError(exc, monitorId, dispatch) {
  // TODO: We could make this behavior generic by enabling consumers to attach
  // an error serialization method to the monitored thunk.
  dispatch((0, _actions.setError)(monitorId, getErrorData(exc)));
}

function monitoredAction(action) {
  var monitorId = action.monitorId;
  var loadingAction = (0, _actions.setLoading)(monitorId);
  var loadedAction = (0, _actions.setLoaded)(monitorId);

  function asyncMonitoredAction(_x, _x2) {
    return _asyncMonitoredAction.apply(this, arguments);
  }

  function _asyncMonitoredAction() {
    _asyncMonitoredAction = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(loadingAction);
              _context.prev = 1;
              _context.next = 4;
              return action(dispatch, getState);

            case 4:
              result = _context.sent;
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              recordError(_context.t0, monitorId, dispatch);
              dispatch(loadedAction);
              throw _context.t0;

            case 12:
              dispatch(loadedAction);
              return _context.abrupt("return", result);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));
    return _asyncMonitoredAction.apply(this, arguments);
  }

  return asyncMonitoredAction;
}

var thunkMonitor = function thunkMonitor() {
  return function (next) {
    return function (action) {
      if (action.monitorId) {
        action = monitoredAction(action);
      }

      return next(action);
    };
  };
};

exports.thunkMonitor = thunkMonitor;